/*
 * Copyright (c) 2016 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * Sends response event to outer frame.
 *
 * @param originalEvent event that triggered original action, if undefined the logic was initiated by live validation.
 * @param eventType type of response event, depend on original action.
 * @param responseData the data returned by OPG during action execution that triggered this response event.
 */
function sendResponseMessage(originalEvent, eventType, responseData) {
    var message = { type: eventType, response: responseData };
    if (originalEvent) {
        if (originalEvent.data['action_id']) {
            message['action_id'] = originalEvent.data['action_id'];
        }
        originalEvent.source.postMessage(message, originalEvent.origin);
    } else {
        // sending message to a parent frame
        window.parent.postMessage(message, '*');
    }
}
module.exports = sendResponseMessage;
